module.exports = __webpack_public_path__ + "img/heroimg.2b0c2438.png";